/*
 * fn: compareCardRefs
 *
 * Compares two cardRef objects, returns a sort()able numbe response
 *
 */
import { type CardRefType } from '@/defs/card'
import { compareText } from '@/utils/commonUtil'

import { parseCardId } from './parseCardId'

export const compareCardRefs = (a: CardRefType, b: CardRefType) =>
  compareText(parseCardId(a.cardId).slug, parseCardId(b.cardId).slug) || compareText(a.cardId, b.cardId)
